import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const ProductReviewsPage = lazy(
  () =>
    import('./ProductReviewsPage.eager').then(mod => ({
      default: mod.ProductReviewsPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
